import { request } from '../request';

type AccountFolderBody = {
  label: string;
  scope: 'COMPANY' | 'PERSONAL';
};

/**
 * Fetches a list of provider cohorts and filter sets folders.
 */
export const getAccountFolders = async () => {
  return await request({
    url: `/v1/accounts/filter-set-folders/`,
    method: 'GET',
  });
};

/**
 * Fetches provider cohorts and filter sets data by id.
 */
export const getAccountFolderById = async (id: string) => {
  return await request({
    url: `/v1/accounts/filter-set-folders/${id}/`,
    method: 'GET',
  });
};

/**
 * Creates a new account folder.
 */
export const createAccountFolder = async (data: AccountFolderBody) => {
  return await request({
    url: `/v1/accounts/filter-set-folders/`,
    method: 'POST',
    data,
  });
};

/**
 * Updates an account folder.
 */
export const updateAccountFolder = async (
  id: string,
  data: AccountFolderBody
) => {
  return await request({
    url: `/v1/accounts/filter-set-folders/${id}/`,
    method: 'PATCH',
    data,
  });
};

/**
 * Deletes an account folder.
 */
export const deleteAccountFolder = async (id: string) => {
  return await request({
    url: `/v1/accounts/filter-set-folders/${id}/`,
    method: 'DELETE',
  });
};
